import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { CreateJalapenoAccount } from 'components/infoTech/components/createJalapenoAccount';
import { SearchJalapenoRole } from 'components/infoTech/components/searchJalapenoRole';
import { ViewJalapenoAccounts } from 'components/infoTech/components/viewJalapenoAccounts';
import { TabPanel } from 'shared';

function JalapenoAccounts({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="JalapenoAccounts_tab" label="Jalapeno Accounts" value="0" />
                <Tab id="CreateJalapenoAccount_tab" label="Create Jalapeno Account" value="1" />
                <Tab id="SearchByRole_tab" label="Search by role" value="2" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewJalapenoAccounts />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateJalapenoAccount />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <SearchJalapenoRole />
            </TabPanel>
        </Paper>
    );
}

export { JalapenoAccounts };
